<template>
    <component @input="$emit('input', $event)" :value="value" :is="name" v-if="hasComponent"></component>
</template>
<script>
    let components = {
        id10: () => import('./id10/index'),
        id11: () => import('./id11/index'),
        id12: () => import('./id12-13/index'),
        id13: () => import('./id12-13/index'),
        id15: () => import('./id15/index'),
        id16: () => import('./id16-17/index'),
        id17: () => import('./id16-17/index'),
        id18: () => import('./id18-19/index'),
        id19: () => import('./id18-19/index'),
        id20: () => import('./id20/index'),
        id21: () => import('./id21/index'),
        id22: () => import('./id22-23/index'),
        id23: () => import('./id22-23/index'),
        id24: () => import('./id24-25/index'),
        id25: () => import('./id24-25/index'),
        id26: () => import('./id26-27/index'),
        id27: () => import('./id26-27/index'),
        id28: () => import('./id28-29-31/index'),
        id29: () => import('./id28-29-31/index'),
        id31: () => import('./id28-29-31/index'),
        id32: () => import('./id32/index'),
        id33: () => import('./id33-34/index'),
        id34: () => import('./id33-34/index'),
        id35: () => import('./id35-36-37/index'),
        id36: () => import('./id35-36-37/index'),
        id37: () => import('./id35-36-37/index'),
        id38: () => import('./id38/index'),
        id39: () => import('./id39/index'),
        id40: () => import('./id40-41/index'),
        id41: () => import('./id40-41/index'),
        id42: () => import('./id42-43/index'),
        id43: () => import('./id42-43/index'),
        id44: () => import('./id44-45-46/index'),
        id45: () => import('./id44-45-46/index'),
        id46: () => import('./id44-45-46/index'),
        id47: () => import('./id47-48-49/index'),
        id48: () => import('./id47-48-49/index'),
        id49: () => import('./id47-48-49/index'),
        id50: () => import('./id50/index'),
        id51: () => import('./id51-52/index'),
        id52: () => import('./id51-52/index'),
        id53: () => import('./id53/index'),
        id54: () => import('./id54/index'),
        id55: () => import('./id55/index'),
        id56: () => import('./id56/index'),
        id57: () => import('./id57/index'),
        id58: () => import('./id58/index'),
        id59: () => import('./id59-60-61/index'),
        id60: () => import('./id59-60-61/index'),
        id61: () => import('./id59-60-61/index'),
        id62: () => import('./id62/index'),
        id63: () => import('./id63-64-65/index'),
        id64: () => import('./id63-64-65/index'),
        id65: () => import('./id63-64-65/index'),
        id66: () => import('./id66/index'),
        id67: () => import('./id67-68-69/index'),
        id68: () => import('./id67-68-69/index'),
        id69: () => import('./id67-68-69/index'),
        id70: () => import('./id70-71-72/index'),
        id71: () => import('./id70-71-72/index'),
        id72: () => import('./id70-71-72/index'),
        id73: () => import('./id73/index'),
        id74: () => import('./id74/index'),
        id75: () => import('./id75-76-77/index'),
        id76: () => import('./id75-76-77/index'),
        id77: () => import('./id75-76-77/index'),
        id78: () => import('./id78-79-80/index'),
        id79: () => import('./id78-79-80/index'),
        id80: () => import('./id78-79-80/index'),
        id81: () => import('./id81/index'),
        id82: () => import('./id82/index'),
        id83: () => import('./id83-84/index'),
        id84: () => import('./id83-84/index'),
        id85: () => import('./id85/index'),
        id86: () => import('./id86-87/index'),
        id87: () => import('./id86-87/index'),
        id88: () => import('./id88-89-90-91/index'),
        id89: () => import('./id88-89-90-91/index'),
        id90: () => import('./id88-89-90-91/index'),
        id91: () => import('./id88-89-90-91/index')
    }
    export default {
        props: {
            id: [String, Number],
            value: [String, Number, Boolean, Array, Object]
        },
        components: {
            ...components
        },
        computed: {
            name () {
                return 'id' + this.id
            },
            hasComponent () {
                return !!components[this.name]
            }
        }
    }
</script>
